var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts-group-details-view"},[(_vm.loaded)?_c('HubContactsGroupsDetail',{attrs:{"name":"contact-group-detail"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }